/* ============================================================================
 * ICON — รหัสตัวอักษร FontAwesome (fa-light-300) ที่ใช้ในหน้า Homepage
 * เก็บเป็น \u escape เพื่อให้อ่านออกในโค้ด (ถ้าใส่อักขระตรง ๆ จะมองไม่เห็นในโปรแกรมแก้ไข)
 * ใช้คู่กับ <span className="hm-ico">{ICON.search}</span>
 * NOTE : โปรเจกต์โหลดเฉพาะฟอนต์ชุด light ไม่มีชุด brand ไอคอนโซเชียลจึงใช้
 *        ไอคอนทั่วไปแทน (globe / comment / play-circle / camera)
 * ========================================================================== */
const ICON = {
  search: "\uf002",
  heart: "\uf004",
  user: "\uf007",
  chevron_left: "\uf053",
  chevron_right: "\uf054",
  chevron_down: "\uf078",
  chevron_up: "\uf077",
  marker: "\uf3c5",
  building: "\uf1ad",
  money: "\uf0d6",
  bed: "\uf236",
  bath: "\uf2cd",
  area: "\uf065",
  floor: "\uf5fd",
  eye: "\uf06e",
  eye_slash: "\uf070",
  clock: "\uf017",
  phone: "\uf095",
  mail: "\uf0e0",
  bullhorn: "\uf0a1",
  headset: "\uf590",
  check: "\uf00c",
  bars: "\uf0c9",
  close: "\uf00d",
  bolt: "\uf0e7",
  home: "\uf015",
  file: "\uf15c",
  tag: "\uf02b",
  crown: "\uf521",
  shield: "\uf3ed",
  star: "\uf005",

  /* ---- แถวหมวดหมู่ / ไลฟ์สไตล์ / แนวรถไฟฟ้า (หน้าแรก) ---- */
  /* ทาวน์โฮม : ใช้ไอคอนชั้นซ้อน (layer-group) สื่อถึงบ้านแถวติดกัน
     ห้ามใช้รหัสเดียวกับ building เพราะชุดไอคอนให้เลือกในหน้าแอดมินใช้ตัวอักษร
     เป็น key ของ React ถ้าซ้ำกันจะเลือกทีเดียวติดสองปุ่ม */
  town: "\uf5fd",
  shop: "\uf54e",          // อาคารพาณิชย์ / ร้านค้า
  subway: "\uf239",        // รถไฟฟ้าใต้ดิน
  plane: "\uf072",         // แอร์พอร์ตลิงก์
  paw: "\uf1b0",           // เลี้ยงสัตว์ได้
  graduation: "\uf19d",    // ใกล้สถานศึกษา
  chart_line: "\uf201",    // น่าลงทุน
  gift: "\uf06b",          // โปรโมชั่น
  briefcase: "\uf0b1",     // โฮมออฟฟิศ
  handshake: "\uf2b5",     // บริการหลังการขาย
  calculator: "\uf1ec",    // ช่วยเรื่องสินเชื่อ
  users: "\uf0c0",         // ทีมงาน
  globe: "\uf0ac",         // โซเชียล (ไม่มีฟอนต์ชุด brand)
  camera: "\uf030",
  arrow_right: "\uf061",

  /* ---- ใช้ในหน้ารายละเอียดทรัพย์ (/property/:id) ---- */
  car: "\uf1b9",
  compass: "\uf14e",
  share: "\uf1e0",
  calendar: "\uf073",
  map: "\uf5a0",
  image: "\uf03e",
  play: "\uf144",
  copy: "\uf0c5",
  check_circle: "\uf058",
  external: "\uf35d",
  comment: "\uf075",
  train: "\uf238",
  hospital: "\uf0f8",
  school: "\uf549",
  cart: "\uf07a",
  tree: "\uf1bb",
  ruler: "\uf545",
  key: "\uf084",
  lock: "\uf023",
  download: "\uf019",
  print: "\uf02f",
  info: "\uf05a",
  chevron_right_small: "\uf105",

  /* ---- แถบเมนูตอนล็อกอินอยู่ (พาร์ตเนอร์ / ผู้ใช้ภายในที่เปิดเว็บสาธารณะ) ---- */
  grid: "\uf00a",          // ไปหลังบ้าน (มุมมองตาราง = แดชบอร์ด)
  logout: "\uf2f5",        // ออกจากระบบ
};

export default ICON;
